import type { ICoverageCertificatePayload } from "@/model/coverage-certificate";
import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";

export const fetchCoverageCertificate = async (
  payload: ICoverageCertificatePayload,
) => {
  const url = API_ENDPOINTS.COVERAGE_CERTIFICATE;
  const { token, ...payloadData } = payload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
  };

  return httpClient
    .post(url, payloadData, config)
    .then((response) => response.data);
};
